module.exports = __webpack_public_path__ + "static/img/product22.9332903.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/product22.png
// module id = v8Cu
// module chunks = 13